import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/stock/symbole-doutil-rempli-de-filtre-blanc.png'


const _withScopeId = n => (_pushScopeId("data-v-17f3fc2f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "vld-parent" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon-container" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1))
const _hoisted_3 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!
  const _component_ErrorModal = _resolveComponent("ErrorModal")!
  const _component_Header = _resolveComponent("Header")!
  const _component_GlobalFilterModal = _resolveComponent("GlobalFilterModal")!
  const _component_Global = _resolveComponent("Global")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_loading, {
        active: $setup.isLoading,
        "onUpdate:active": _cache[0] || (_cache[0] = ($event: any) => (($setup.isLoading) = $event)),
        "can-cancel": false,
        "is-full-page": true
      }, null, 8, ["active"])
    ]),
    ($setup.errorModalOpen)
      ? (_openBlock(), _createBlock(_component_ErrorModal, {
          key: 0,
          messages: $setup.errorMessage || [$setup.t('generic.error')],
          onClose: $setup.CloseErrorModal
        }, null, 8, ["messages", "onClose"]))
      : _createCommentVNode("", true),
    _createVNode(_component_Header, {
      title: $setup.t('components.sidebar.menu.stock'),
      onBack: $setup.GoBack
    }, {
      subHeader: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('generic.global')), 1)
      ]),
      endButtons: _withCtx(() => [
        _createElementVNode("div", {
          id: "FilterButton",
          class: "button-container",
          onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.globalFilterModalOpen = $setup.ToggleFilter($setup.globalFilterModalOpen)))
        }, [
          _hoisted_2,
          _createElementVNode("input", {
            type: "button",
            value: $setup.t('generic.filters')
          }, null, 8, _hoisted_3)
        ])
      ]),
      _: 1
    }, 8, ["title", "onBack"]),
    ($setup.globalFilterModalOpen)
      ? (_openBlock(), _createBlock(_component_GlobalFilterModal, {
          key: 1,
          tableData: $setup.globalTableData,
          onApply: $setup.ApplyGlobalFilter,
          globalFilterFormData: $setup.globalFilterFormData,
          onReset: $setup.ResetGlobalFilter,
          onClose: () => ($setup.globalFilterModalOpen = false)
        }, null, 8, ["tableData", "onApply", "globalFilterFormData", "onReset", "onClose"]))
      : _createCommentVNode("", true),
    _createVNode(_component_Global, {
      openActivityPage: $setup.OpenActivityPage,
      tableData: $setup.globalTableFilteredData
    }, null, 8, ["openActivityPage", "tableData"])
  ], 64))
}